export const MIN_SEARCH_CHAR_COUNT = 3;
export const MIN_SEARCH_CHAR_MESSAGE = `Please enter at least ${MIN_SEARCH_CHAR_COUNT} characters`;

export function shouldPreventLeadingSpace(event: Event): boolean {
  if (!(event instanceof KeyboardEvent)) return false;
  if (event.key !== ' ') return false;

  const input = event.target as HTMLInputElement | null;
  if (!input) return false;

  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? selectionStart;
  const nextValue = `${input.value.slice(0, selectionStart)} ${input.value.slice(selectionEnd)}`;

  return /^\s/.test(nextValue);
}

export function removeLeadingSearchSpaces(value: string | null | undefined): string {
  return String(value ?? '').replace(/^\s+/, '');
}

export function countSearchCharacters(value: string | null | undefined): number {
  return removeLeadingSearchSpaces(value).replace(/\s/g, '').length;
}

export function normalizeSearchTerm(value: string | null | undefined): string {
  return removeLeadingSearchSpaces(value).trim();
}

export function hasMinimumSearchCharacters(value: string | null | undefined): boolean {
  return countSearchCharacters(value) >= MIN_SEARCH_CHAR_COUNT;
}
